// 숙소정보 가져오기

import { useMutation } from "@tanstack/react-query";
import { lodListApi } from "components/api/comm";
import { dashbordApi, dayChkInListApi } from "components/api/home";
import { apifield } from "components/utils/comm";
import { IDayChkInList, IDayPayInf } from "interface/home";
import { useEffect, useRef } from "react";
import useAuthStore from "store/auth";
import useLodStore from "store/lod";

// 대시보드 데이터 가져오기
export const useGetData = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const lod = useLodStore((state) => state.lod);
  const dayPayInfRef = useRef<IDayPayInf>();
  const dayChkInListRef = useRef<IDayChkInList[]>([]);

  const mutation = useMutation({
    mutationKey: ["home-dashbord"],
    mutationFn: dashbordApi,
    onSuccess: (res) => {
      if (res) {
        const { lodList, dayPayInf, dayChkInList } = res?.data;
        // lodsRef.current = lodList;
        dayPayInfRef.current = dayPayInf;
        dayChkInListRef.current = dayChkInList.map(
          (list: IDayChkInList, index: number) => {
            return {
              No: index + 1,
              ...list,
              resvCstnm: list.resvCstSurnm + list.resvCstFstnm,
              resvDt: list.resvSDt + "/" + list.resvEDt,
            };
          }
        );
      }
    },
  });

  useEffect(() => {
    if (isLogin && lod?.lodNo) {
      mutation.mutate(lod.lodNo);
    }
  }, [isLogin, lod?.lodNo]);

  return {
    dayChkInList: dayChkInListRef.current,
    dayPayInf: dayPayInfRef.current,
  };
};

// 오늘 예약고객 데이터 가져오기
export const useGetResvData = () => {
  const dayChkInListRef = useRef<IDayChkInList[]>([]);
  const mutation = useMutation({
    mutationFn: dayChkInListApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          dayChkInListRef.current =
            res.data?.dayChkInList &&
            res.data.dayChkInList.map((day: IDayChkInList, index: number) => {
              return {
                No: index + 1,
                ...day,
                resvCstnm: day.resvCstSurnm + day.resvCstFstnm,
                resvDt: day.resvSDt + "/" + day.resvEDt,
              };
            });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  return {
    dayChkInList: dayChkInListRef.current,
    mutation,
  };
};

// 오늘 예약 고객 상세정보 조회
export const useResvDetail = () => {};

// 숙소리스트
export const useGetLodList = () => {
  const lodListRef = useRef([]);
  const isLogin = useAuthStore((state) => state.isLogin);
  const mutation = useMutation({
    mutationKey: ["home-lod-list"],
    mutationFn: lodListApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //
          lodListRef.current = data.lodList;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  //   useEffect(() => {
  //     if (isLogin) {
  //       mutation.mutate();
  //     }
  //   }, [isLogin]);

  return {
    lodList: lodListRef.current,
  };
};
